import { render, staticRenderFns } from "./ModificationRequests.vue?vue&type=template&id=3331c884"
import script from "./ModificationRequests.vue?vue&type=script&lang=js"
export * from "./ModificationRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports